import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectGuides = () => {
  return <Navigate to="/guides/developer-platform-overview" />;
};

export default RedirectGuides;